import QrCode from './qr-code.vue';

export default QrCode;
